import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { UtilsService } from 'src/app/services/utils.service';


@Component({
  selector: 'app-prenotazioni-teetime',
  templateUrl: './prenotazioni-teetime.component.html',
  styleUrls: ['./prenotazioni-teetime.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class PrenotazioniTeetimeComponent implements OnInit, OnDestroy {
  store: string;
  isLoading: boolean;
  sub: Subscription;
  firstRun: boolean;

  constructor(public app: AppComponent,
    public sanitizer: DomSanitizer,
    public utils: UtilsService,
  ) {
    this.isLoading = false;
    this.sub = new Subscription();
    this.firstRun = false;
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
  }
}
